import type { PlainDate } from "@sa-nu/shared-utils/date";

// 既存の CI/CO がある場合は泊数（existingFirstNight〜existingLastNight の差分）を維持し、
// selectedNight を新しい firstNight としてその泊数分だけ lastNight をずらす。
export function computePendingStayRange({
  selectedNight,
  existingFirstNight,
  existingLastNight,
}: {
  selectedNight: PlainDate;
  existingFirstNight: PlainDate | null;
  existingLastNight: PlainDate | null;
}): { firstNight: PlainDate; lastNight: PlainDate } {
  if (existingFirstNight === null || existingLastNight === null) {
    return { firstNight: selectedNight, lastNight: selectedNight };
  }

  const nightsSpan = existingFirstNight.until(existingLastNight, {
    largestUnit: "day",
  }).days;
  return {
    firstNight: selectedNight,
    lastNight: selectedNight.add({ days: nightsSpan }),
  };
}
